import { render, staticRenderFns } from "./OfferMetricsTable.vue?vue&type=template&id=949811aa&scoped=true&"
import script from "./OfferMetricsTable.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OfferMetricsTable.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949811aa",
  null
  
)

export default component.exports